var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoonSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.527,
    height: 15.747,
    viewBox: "0 0 14.527 15.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37531",
    "data-name": "Path 37531",
    d: "M0,7.749A8.023,8.023,0,0,1,5.778.071c.355-.1.692-.142.932.213s.08.648-.124.95A6.648,6.648,0,0,0,10.8,11.574a6.435,6.435,0,0,0,2.76-.053.692.692,0,0,1,.719,1.163A7.991,7.991,0,0,1,0,7.749Zm11.894,5.343a8.023,8.023,0,0,1-6.506-3.63,7.94,7.94,0,0,1-.754-7.491A6.563,6.563,0,0,0,1.4,7.784a6.315,6.315,0,0,0,3.737,5.885,6.363,6.363,0,0,0,6.763-.586Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonSelected);
export default __webpack_public_path__ + "static/media/Moon-Selected.97d5e7a71a83e73b23f2001c5165f9e4.svg";
export { ForwardRef as ReactComponent };